import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "396",
  "slug": "best-books-about-maps-and-geography",
  "title": "The Best Books About Maps and Geography for Curious Minds",
  "excerpt": "From geopolitics to the strange history of cartography, these books will change how you see the map. A reading list for anyone who loves the world.",
  "date": "2026-06-10",
  "category": "Community",
  "image": "https://images.unsplash.com/photo-1524661135-423995f22d0b?ixid=M3w5NjY4NzN8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwbWFwJTIwYXRsYXN8ZW58MXwwfHx8MTc4MTA3OTIxOHww&ixlib=rb-4.1.0&w=800&q=80&fit=crop",
  "readTime": "7 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Geography is one of those subjects that gets dramatically more interesting the moment you leave the classroom behind. The right book can turn a flat list of capitals into a story about power, rivers, ambition, and accident. If you love poring over maps and wondering why the world is shaped the way it is, here is a reading list to keep you up far too late."
    },
    {
      "type": "heading",
      "text": "For Understanding Why the World Is the Way It Is"
    },
    {
      "type": "paragraph",
      "text": "Tim Marshall's Prisoners of Geography is the natural starting point. It argues that mountains, rivers, and coastlines quietly dictate the fate of nations, and it walks region by region through how physical geography shapes politics. It is readable, opinionated, and the kind of book you immediately want to discuss with someone."
    },
    {
      "type": "paragraph",
      "text": "For a calmer, more academic companion, Harm de Blij's Why Geography Matters makes the case that geographic literacy is not a nice-to-have but essential for understanding climate, conflict, and globalisation. Together the two books form a strong foundation in thinking geographically rather than just memorising places."
    },
    {
      "type": "heading",
      "text": "For the History and Romance of Maps"
    },
    {
      "type": "paragraph",
      "text": "Simon Garfield's On the Map is a warm, anecdote-rich tour through the history of cartography, from ancient world maps to the way digital navigation is reshaping how we find our way. Ken Jennings, the Jeopardy champion, brings humour and obsession in equal measure in Maphead, a love letter to the people who collect, memorise, and adore maps."
    },
    {
      "type": "paragraph",
      "text": "For something stranger, Edward Brooke-Hitching's The Phantom Atlas collects the islands, mountains, and entire countries that appeared on old maps but never actually existed, a reminder that cartography has always been part science and part wishful thinking."
    },
    {
      "type": "heading",
      "text": "For Armchair Exploration"
    },
    {
      "type": "paragraph",
      "text": "Judith Schalansky's Atlas of Remote Islands is a quietly beautiful book that profiles fifty tiny, far-flung islands the author admits she will never visit, pairing each map with a strange true story. It captures the particular pleasure of exploring places purely on paper, which is the same pleasure that draws people to geography games in the first place."
    },
    {
      "type": "heading",
      "text": "For Younger Readers and Families"
    },
    {
      "type": "paragraph",
      "text": "Aleksandra and Daniel Mizielinski's Maps is an oversized, lavishly illustrated atlas that children pore over for hours, packed with the food, animals, landmarks, and quirks of each country. It is the kind of book that turns a rainy afternoon into an imaginary trip around the world, and it plants the seed of geographic curiosity early."
    },
    {
      "type": "list",
      "items": [
        "Prisoners of Geography by Tim Marshall, for geopolitics through the lens of terrain",
        "On the Map by Simon Garfield, for the history of cartography",
        "Maphead by Ken Jennings, for the joy of map obsession",
        "The Phantom Atlas by Edward Brooke-Hitching, for places that never existed",
        "Atlas of Remote Islands by Judith Schalansky, for armchair exploration"
      ]
    },
    {
      "type": "paragraph",
      "text": "The best thing about a geography book is the itch it leaves behind to go and look at the world yourself. When that itch strikes, a few rounds of EarthGuessr are the perfect way to scratch it, putting the places you have been reading about right in front of you, seen from above."
    }
  ]
};
